var _g, _path, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _path2, _g16, _g17, _g18, _g19, _g20, _g21, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGenericError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 507,
    height: 334,
    viewBox: "0 0 507 334",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1177_39292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.3303 117.328H271.511C274.482 117.328 276.891 119.737 276.891 122.709V267.658C276.891 270.629 274.482 273.038 271.511 273.038H59.3303C56.3586 273.038 53.9495 270.629 53.9495 267.658V122.709C53.9495 119.737 56.3586 117.328 59.3303 117.328Z",
    stroke: "#5653D2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M286.659 126.298H378.421C381.917 126.298 384.752 123.464 384.752 119.968V79.7248C384.752 76.2287 381.917 73.3945 378.421 73.3945H258.822C255.326 73.3945 252.492 76.2287 252.492 79.7248V109.766",
    stroke: "#5653D2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1177_39292)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 261.153,
    y: 84.262,
    width: 45.4939,
    height: 11.3269,
    rx: 5.38073,
    stroke: "#5653D2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1177_39292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.656 157.16H306.227C309.723 157.16 312.557 154.325 312.557 150.829V150.264C312.557 146.768 309.723 143.934 306.227 143.934H286.656",
    stroke: "#5653D2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1177_39292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.656 204.551H306.227C309.723 204.551 312.557 207.385 312.557 210.881V211.446C312.557 214.943 309.723 217.777 306.227 217.777H286.656",
    stroke: "#5653D2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1177_39292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.661 115.277H329.928C333.424 115.277 336.258 112.443 336.258 108.946V108.381C336.258 104.885 333.424 102.051 329.928 102.051H269.846C266.35 102.051 263.516 104.885 263.516 108.381V108.664",
    stroke: "#5653D2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1177_39292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.656 162.668H330.474C333.97 162.668 336.805 165.502 336.805 168.998V169.564C336.805 173.06 333.97 175.894 330.474 175.894H286.656",
    stroke: "#5653D2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_1177_39292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.656 223.289H331.576C335.073 223.289 337.907 226.123 337.907 229.619V230.185C337.907 233.681 335.073 236.515 331.576 236.515H286.656",
    stroke: "#5653D2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_1177_39292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.656 132.91H380.623C384.119 132.91 386.953 135.744 386.953 139.24V181.688C386.953 185.184 384.119 188.018 380.623 188.018H286.656",
    stroke: "#5653D2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_1177_39292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.656 247.537H380.623C384.119 247.537 386.953 244.702 386.953 241.206V200.963C386.953 197.467 384.119 194.633 380.623 194.633H286.656",
    stroke: "#5653D2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_1177_39292)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 351.683,
    cy: 100.948,
    r: 4.56127,
    stroke: "#5653D2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_1177_39292)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 352.784,
    cy: 160.464,
    r: 4.56127,
    stroke: "#5653D2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_1177_39292)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 352.784,
    cy: 221.085,
    r: 4.56127,
    stroke: "#5653D2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_1177_39292)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 366.011,
    cy: 100.948,
    r: 4.56127,
    stroke: "#5653D2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_1177_39292)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 367.112,
    cy: 160.464,
    r: 4.56127,
    stroke: "#5653D2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d_1177_39292)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 367.112,
    cy: 221.085,
    r: 4.56127,
    stroke: "#5653D2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M249.186 73.3945C248.078 73.3945 200.139 73.3945 171.412 73.3945C168.098 73.3945 165.422 76.0808 165.422 79.3945V110.868",
    stroke: "#5653D2",
    strokeWidth: 1.9,
    strokeDasharray: "4 4"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_d_1177_39292)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-18-inside-1_1177_39292",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.523 156.125C140.051 153.652 136.043 153.652 133.571 156.125L124.598 165.097C122.126 167.569 122.126 171.577 124.598 174.05L147.397 196.849L124.593 219.653C122.121 222.125 122.121 226.133 124.593 228.605L133.566 237.578C136.038 240.05 140.046 240.05 142.518 237.578L165.322 214.774L188.125 237.576C190.597 240.049 194.605 240.049 197.077 237.576L206.05 228.604C208.522 226.132 208.522 222.124 206.05 219.651L183.247 196.849L206.045 174.051C208.517 171.579 208.517 167.571 206.045 165.098L197.073 156.126C194.6 153.654 190.592 153.654 188.12 156.126L165.322 178.924L142.523 156.125Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M133.571 156.125L134.914 157.467L133.571 156.125ZM142.523 156.125L143.866 154.782L142.523 156.125ZM124.598 165.097L125.941 166.44L124.598 165.097ZM124.598 174.05L125.941 172.707L124.598 174.05ZM147.397 196.849L148.74 198.192L150.083 196.849L148.74 195.506L147.397 196.849ZM124.593 219.653L123.25 218.31L123.25 218.31L124.593 219.653ZM124.593 228.605L125.936 227.262H125.936L124.593 228.605ZM133.566 237.578L134.909 236.235L134.909 236.235L133.566 237.578ZM142.518 237.578L143.861 238.921L142.518 237.578ZM165.322 214.774L166.665 213.431L165.322 212.088L163.979 213.431L165.322 214.774ZM197.077 237.576L198.42 238.919L198.42 238.919L197.077 237.576ZM206.05 228.604L204.707 227.261H204.707L206.05 228.604ZM183.247 196.849L181.904 195.506L180.562 196.849L181.904 198.192L183.247 196.849ZM206.045 174.051L204.702 172.708L204.702 172.708L206.045 174.051ZM206.045 165.098L207.388 163.756V163.756L206.045 165.098ZM197.073 156.126L195.73 157.469V157.469L197.073 156.126ZM188.12 156.126L189.463 157.469V157.469L188.12 156.126ZM165.322 178.924L163.979 180.267L165.322 181.61L166.665 180.267L165.322 178.924ZM134.914 157.467C136.644 155.737 139.45 155.737 141.18 157.467L143.866 154.782C140.652 151.568 135.442 151.568 132.228 154.782L134.914 157.467ZM125.941 166.44L134.914 157.467L132.228 154.782L123.255 163.754L125.941 166.44ZM125.941 172.707C124.21 170.976 124.21 168.171 125.941 166.44L123.255 163.754C120.041 166.968 120.041 172.179 123.255 175.392L125.941 172.707ZM148.74 195.506L125.941 172.707L123.255 175.392L146.054 198.192L148.74 195.506ZM125.936 220.996L148.74 198.192L146.054 195.506L123.25 218.31L125.936 220.996ZM125.936 227.262C124.206 225.532 124.206 222.726 125.936 220.996L123.25 218.31C120.037 221.524 120.037 226.734 123.25 229.948L125.936 227.262ZM134.909 236.235L125.936 227.262L123.25 229.948L132.223 238.921L134.909 236.235ZM141.175 236.235C139.445 237.965 136.639 237.965 134.909 236.235L132.223 238.921C135.437 242.134 140.647 242.134 143.861 238.921L141.175 236.235ZM163.979 213.431L141.175 236.235L143.861 238.921L166.665 216.117L163.979 213.431ZM189.468 236.234L166.665 213.431L163.979 216.117L186.782 238.919L189.468 236.234ZM195.734 236.234C194.004 237.964 191.198 237.964 189.468 236.234L186.782 238.919C189.996 242.133 195.206 242.133 198.42 238.919L195.734 236.234ZM204.707 227.261L195.734 236.234L198.42 238.919L207.393 229.947L204.707 227.261ZM204.707 220.994C206.437 222.725 206.437 225.53 204.707 227.261L207.393 229.947C210.606 226.733 210.606 221.522 207.393 218.309L204.707 220.994ZM181.904 198.192L204.707 220.994L207.393 218.309L184.59 195.506L181.904 198.192ZM204.702 172.708L181.904 195.506L184.59 198.192L207.388 175.394L204.702 172.708ZM204.702 166.441C206.433 168.172 206.433 170.978 204.702 172.708L207.388 175.394C210.602 172.18 210.602 166.969 207.388 163.756L204.702 166.441ZM195.73 157.469L204.702 166.441L207.388 163.756L198.415 154.783L195.73 157.469ZM189.463 157.469C191.194 155.738 193.999 155.738 195.73 157.469L198.415 154.783C195.202 151.569 189.991 151.569 186.777 154.783L189.463 157.469ZM166.665 180.267L189.463 157.469L186.777 154.783L163.979 177.581L166.665 180.267ZM141.18 157.467L163.979 180.267L166.665 177.581L143.866 154.782L141.18 157.467Z",
    fill: "#5653D2",
    mask: "url(#path-18-inside-1_1177_39292)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter16_d_1177_39292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.7614 24.5C97.7614 29.2713 94.1094 33.0505 89.7109 33.0505C85.3125 33.0505 81.6605 29.2713 81.6605 24.5C81.6605 19.7287 85.3125 15.9495 89.7109 15.9495C94.1094 15.9495 97.7614 19.7287 97.7614 24.5Z",
    stroke: "#5653D2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter17_d_1177_39292)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 307.211,
    cy: 33.5,
    r: 12.5505,
    stroke: "#5653D2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter18_d_1177_39292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.348 297.956L235.196 297.548L239.974 305.006L235.903 312.873L227.056 313.281L222.278 305.823L226.348 297.956Z",
    stroke: "#5653D2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter19_d_1177_39292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.348 188.246L402.987 180.701L411.841 180.946L416.056 188.737L411.416 196.282L402.562 196.036L398.348 188.246Z",
    stroke: "#5653D2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter20_d_1177_39292)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118.656,
    y: 57.1629,
    width: 30.053,
    height: 30.053,
    transform: "rotate(15 118.656 57.1629)",
    stroke: "#5653D2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1177_39292",
    x: 35.9083,
    y: 101.819,
    width: 259.024,
    height: 191.793,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39292"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39292",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1177_39292",
    x: 243.111,
    y: 68.7529,
    width: 81.5764,
    height: 47.4093,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39292"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39292",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1177_39292",
    x: 268.615,
    y: 128.424,
    width: 61.9834,
    height: 49.3085,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39292"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39292",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1177_39292",
    x: 268.615,
    y: 189.042,
    width: 61.9834,
    height: 49.3085,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39292"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39292",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1177_39292",
    x: 245.474,
    y: 86.5417,
    width: 108.825,
    height: 49.3085,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39292"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39292",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1177_39292",
    x: 268.615,
    y: 147.159,
    width: 86.231,
    height: 49.3085,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39292"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39292",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_1177_39292",
    x: 268.615,
    y: 207.78,
    width: 87.3331,
    height: 49.3085,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39292"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39292",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_1177_39292",
    x: 268.615,
    y: 117.401,
    width: 136.379,
    height: 91.1906,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39292"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39292",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_1177_39292",
    x: 268.615,
    y: 179.124,
    width: 136.379,
    height: 88.9862,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39292"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39292",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_1177_39292",
    x: 329.08,
    y: 80.8779,
    width: 45.2051,
    height: 45.2052,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39292"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39292",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_1177_39292",
    x: 330.182,
    y: 140.393,
    width: 45.2051,
    height: 45.2052,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39292"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39292",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_1177_39292",
    x: 330.182,
    y: 201.015,
    width: 45.2051,
    height: 45.2052,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39292"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39292",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_1177_39292",
    x: 343.408,
    y: 80.8779,
    width: 45.2051,
    height: 45.2052,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39292"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39292",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_1177_39292",
    x: 344.51,
    y: 140.393,
    width: 45.2051,
    height: 45.2052,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39292"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39292",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_1177_39292",
    x: 344.51,
    y: 201.015,
    width: 45.2051,
    height: 45.2052,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39292"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39292",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_1177_39292",
    x: 105.648,
    y: 139.711,
    width: 119.348,
    height: 119.345,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39292"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39292",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_1177_39292",
    x: 63.6192,
    y: 0.440368,
    width: 52.1835,
    height: 53.1835,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39292"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39292",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d_1177_39292",
    x: 276.619,
    y: 5.44037,
    width: 61.1835,
    height: 61.1835,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39292"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39292",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_d_1177_39292",
    x: 204.091,
    y: 282.015,
    width: 54.0698,
    height: 51.8644,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39292"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39292",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_d_1177_39292",
    x: 380.16,
    y: 165.177,
    width: 54.0834,
    height: 51.693,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39292"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39292",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_d_1177_39292",
    x: 92.6229,
    y: 41.4404,
    width: 73.3165,
    height: 73.3165,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39292"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39292",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericError);
export default __webpack_public_path__ + "static/media/generic-error.9a1513c76ad0499d4a05bf34b44769d8.svg";
export { ForwardRef as ReactComponent };